<style scoped>
    .health-status-indicator.test-ok {
        color: #0c0;
    }

    .health-status-indicator.test-warn {
        color: #fc0;
    }

    .health-status-indicator.test-failed {
        color: #e00;
    }

    .health-status-indicator.not-tested {
        color: #ccc;
    }

</style>
<template>
    <icon :name="iconName" class="health-status-indicator" :class="[className]" :title="displayName"></icon>
</template>
<script>
    import 'vue-awesome/icons/circle';
    import 'vue-awesome/icons/check-circle';
    import 'vue-awesome/icons/exclamation-circle';
    import 'vue-awesome/icons/times-circle';
    import 'vue-awesome/icons/question-circle';
    import Icon from 'vue-awesome/components/Icon.vue';

    const STATUS_NOT_TESTED = 0;
    const STATUS_OK = 1;
    const STATUS_WARNING = 2;
    const STATUS_ERROR = 3;

    export default {
        props: [
            'statusValue'
        ],

        computed: {
            className() {
                return this.statusValueToClassName(this.statusValue);
            },
            displayName() {
                return this.statusValueToDisplayName(this.statusValue);
            },
            iconName() {
                return this.statusValueToIconName(this.statusValue);
            }
        },

        components: {
            'icon': Icon
        },

        methods: {
            statusValueToDisplayName(value) {
                switch (value) {
                    case STATUS_NOT_TESTED:
                        return 'Not tested';
                    case STATUS_OK:
                        return 'OK';
                    case STATUS_WARNING:
                        return 'Warning';
                    case STATUS_ERROR:
                        return 'Failed';
                    default:
                        return 'unknown';
                }
            },
            statusValueToClassName(value) {
                switch (value) {
                    case STATUS_NOT_TESTED:
                        return 'not-tested';
                    case STATUS_OK:
                        return 'test-ok';
                    case STATUS_WARNING:
                        return 'test-warn';
                    case STATUS_ERROR:
                        return 'test-failed';
                    default:
                        return 'unknown';
                }
            },
            statusValueToIconName(value) {
                switch (value) {
                    case STATUS_NOT_TESTED:
                        return 'circle';
                    case STATUS_OK:
                        return 'check-circle';
                    case STATUS_WARNING:
                        return 'exclamation-circle';
                    case STATUS_ERROR:
                        return 'times-circle';
                    default:
                        return 'question-circle';
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/HealthStatusIndicator.vue